import { IEditTatPayload, IGetTatList, ITatDetails, ITatListSearch } from "../../../types/master/tatInterface";
import { TatActionTypes, TatActions } from "../../actionTypes/master/tatActionTypes";

// export const createTat = (tat: ITatCreate): TatActionTypes => ({
//   type: TatActions.CREATE_TAT,
//   payload: tat,
// });

export const getTatList = (payload: ITatListSearch): TatActionTypes => ({
  type: TatActions.GET_TAT_LIST,
  payload,
});

export const setTatList = (tatList: Array<IGetTatList>): TatActionTypes => ({
  type: TatActions.SET_TAT_LIST,
  payload: tatList,
});

export const setTatListPageCount = (payload: number): TatActionTypes => ({
  type: TatActions.SET_TAT_LIST_PAGE_COUNT,
  payload,
});

export const getTatDataById = (id: number): TatActionTypes => ({
  type: TatActions.GET_TAT_DATA_BY_ID,
  payload: id,
});

export const setTatDataById = (payload: ITatDetails) => ({
  type: TatActions.SET_TAT_DATA_BY_ID,
  payload,
});

export const editTat = (payload: IEditTatPayload) => ({
  type: TatActions.EDIT_TAT_DATA_BY_ID,
  payload,
});
